import { observable, action } from 'mobx';
import * as SETAPI from 'cd-eft/services/eftSetApi';
import MessageCenter from 'cd-eft/components/common/MessageCenter/MessageCenterVM';

export interface IErrorMessage {
  editingStatus: string;
  readonly errorCode: string;
  errorCategoryCode: string;
  errorShortDescription: string;
  errorDetails: string;
  loggingFlag: string;
  readonly lastChangedBy: string;
  readonly lastChangeDate: string;
  url: string;
  readonly errorCodeLUTId: number;
  originalErrorCode?: string;
  errorCategoryId: number;
  errorCodeStatus: string;
  errorSubCategoryCode: string;
  moduleCode: string;
}

export interface ISelection {
  name: string;
  value: string;
}

export class AdminErrorMessagesVM {
  @observable isLoading: boolean = false;
  @observable searchValue: string = '';

  @observable errorData: IErrorMessage[] = [];
  @observable filteredErrorData: IErrorMessage[] = [];

  @action.bound async getAllErrorHandlings() {
    this.isLoading = true;
    try {
      const response: any = await SETAPI.ErrorHandlingController.getAllErrorHandlingsUsingGET();
      if (response.data) {
        this.errorData = response.data.sort((a, b) => b.lastChangeDate - a.lastChangeDate);
        this.filteredErrorData = [...this.errorData];
      }
    } catch (error) {
      MessageCenter.addError((error as Error).message);
    } finally {
      this.isLoading = false;
    }
  }

  @action.bound filterTable = (value: string) => {
    if (value) {
      const stringValue = value.toString().toLowerCase();
      const newData = this.errorData?.filter((item) => item.errorCode.toString().toLowerCase().includes(stringValue));
      this.filteredErrorData = newData;
    } else {
      this.filteredErrorData = this.errorData;
    }
  };

  @action.bound onChangeSearchInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.searchValue = e.target.value;
    this.filterTable(e.target.value);
  };
}
